<ng-container *hasPermission="['ACCOUNTS_READ','ACCOUNTS_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title d-flex justify-content-between align-items-center">
            <h2>Account</h2>
            <button type="button" class="btn btn-outline-primary" (click)="sync()"
                *hasPermission="['ACCOUNTS_UPDATE','ACCOUNTS_ALL', 'SAFESTREET_ADMIN']">
                <i class="fa-solid fa-rotate me-1"></i>Sincronizza da Keycloak
            </button>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="organization" class="form-label">Ente</label>
                <select class="form-select" id="organization" name="organization"
                    [(ngModel)]="searchCriteria.organizationId" (ngModelChange)="search()">
                    <option [ngValue]="undefined">Tutti</option>
                    <option *ngFor="let organization of organizations" [ngValue]="organization.id">
                        {{organization.name}}
                    </option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label for="username" class="form-label">Username</label>
                <div class="d-flex gap-2">
                    <input type="text" class="form-control" id="username" name="username"
                        [(ngModel)]="searchCriteria.username" (keyup.enter)="search()" />
                    <button type="button" class="btn btn-outline-secondary" (click)="clearFilter()">Cancella</button>
                    <button type="button" class="btn btn-primary" (click)="search()">Cerca</button>
                </div>
            </div>
        </div>

        <div class="section-container">
            <div class="table-responsive">
                <table class="table caption-top table-hover table-striped">
                    <caption>
                        <button type="button" class="btn btn-primary" (click)="add()"
                            *hasPermission="['ACCOUNTS_CREATE','ACCOUNTS_ALL', 'SAFESTREET_ADMIN']"><i bTooltip
                                title="Aggiungi" class="fa-solid fa-plus"></i></button>
                        Risultati trovati: {{totalItems}}
                    </caption>
                    <thead>
                        <tr>
                            <th scope="col" class="row-button-sm"></th>
                            <th scope="col">Username</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Cognome</th>
                            <th scope="col">Email</th>
                            <th scope="col">Ruolo</th>
                            <th scope="col" class="row-button-sm">Attivo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let account of accounts | paginate: {
                        itemsPerPage: searchCriteria.pageSize,
                        currentPage: searchCriteria.pageNumber,
                        totalItems: totalItems } ">
                            <td>
                                <div class="d-flex justify-content-center  align-items-center gap-2">
                                    <div class="cursor-pointer" (click)="edit(account)"
                                        *hasPermission="['ACCOUNTS_UPDATE','ACCOUNTS_ALL', 'SAFESTREET_ADMIN']">
                                        <i bTooltip title="Modifica" class="fa-solid fa-pen"></i>
                                    </div>
                                    <div class="cursor-pointer" (click)="confirmDisable(account)"
                                        *hasPermission="['ACCOUNTS_DELETE','ACCOUNTS_ALL', 'SAFESTREET_ADMIN']">
                                        <i bTooltip title="Disabilita" class="fa-solid fa-ban"></i>
                                    </div>
                                </div>
                            </td>
                            <td>{{account.username}}</td>
                            <td>{{account.firstName}}</td>
                            <td>{{account.lastName}}</td>
                            <td>{{account.email}}</td>
                            <td>{{roleLabel(account.role)}}</td>
                            <td>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                        [checked]="account.enabled" disabled [id]="'accountEnabled-'+account.accountId">
                                    <label class="form-check-label" for="accountEnabled"></label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <pagination-controls (pageChange)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)"
                previousLabel="Precedente" nextLabel="Successiva" screenReaderPaginationLabel="Paginazione"
                screenReaderPageLabel="Pagina" screenReaderCurrentLabel="Vai alla pagina">
            </pagination-controls>
        </div>
    </div>
    <app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
        (modalConfirm)="disableExec()" (modalCancel)="cancelDisable()">
    </app-confirm-alert>
</ng-container>
